import { Navigate, createFileRoute } from "@tanstack/react-router";

/** `/merchandising` opens on the orders desk. */
export const Route = createFileRoute("/_app/merchandising/")({
	component: () => <Navigate to="/merchandising/orders" replace />,
});
